import React from 'react'
import icon from './svgs/arrowleft.svg'
import { BaseIcon } from './_base'

export const ArrowLeftIcon = ({ size, fontSize ,sx}) => {
    return (
        <BaseIcon icon = {icon} {...{fontSize,size,...sx}} />
    )
}
